import React from 'react';
import { Text } from '@mantine/core';
import {
  INFO_CARD_STYLE_PRESETS,
  infoCardSampleContentPatch,
  infoCardStylePatch,
} from '../../../../shared/boxes/infoCard/infoCardStyles';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';
import ThemeStyleGallery from '../../../puck/fields/ThemeStyleGallery';
import StyleCardPreview from '../../../theme/StyleCardPreview';
import styles from './InfoCardStylePicker.module.css';

/**
 * Galerie de styles de Carte info. Un style est un JEU DE VALEURS, pas une
 * variante.
 * Les génériques sont des COPIES : en cliquer un recopie ses valeurs dans le
 * bloc, qui reste « Personnalisé » (aucun n'est jamais surligné). Seul un
 * style du thème se suit (cf. ThemeStyleGallery).
 *
 * Le champ est déclaré sur `titleStyle` faute
 * de prop « style » — les autres passent par dispatch, comme
 * InfoCardIllustrationField est déclaré sur `icon`.
 *
 * Pendant du sélecteur de dispositions de section
 * (puck/fields/SectionLayoutPresetPicker).
 */
export default function InfoCardStylePicker() {
  const { itemProps, updateItemProps } = useSelectedItemProps();

  return (
    <ThemeStyleGallery kind="infoCard" classes={styles}>
      <div className={styles.grid} role="listbox" aria-label="Style de la carte">
        {INFO_CARD_STYLE_PRESETS.map((def) => (
          <button
            key={def.key}
            type="button"
            role="option"
            aria-selected={false}
            title={def.label}
            className={styles.card}
            // Un seul dispatch : le style pose toutes ses props d'un coup,
            // donc une seule entrée d'historique et un seul patch autosave.
            onClick={() => updateItemProps({
              ...infoCardStylePatch(def),
              // Le texte de démonstration suit le modèle : « 98 % / Clients
              // satisfaits » sur un témoignage ne veut rien dire. Ce que
              // l'utilisateur a écrit, lui, n'est jamais remplacé.
              ...infoCardSampleContentPatch(def, itemProps),
              themeStyleId: null,
            })}
          >
            <StyleCardPreview kind="infoCard" values={{ ...def.props, ...def.sample }} />
            <Text size="10px" c="dimmed" lh={1.2} ta="center">
              {def.label}
            </Text>
          </button>
        ))}
      </div>
    </ThemeStyleGallery>
  );
}
